import { FC, PropsWithChildren } from 'react'
import { useGuardOr } from '../../hooks/auth'

interface InternalGuardProps {
  /** O usuário precisa ter ao menos uma destas permissões (ex.: ['OS1']). */
  need: string[]
}

/**
 * Protege rotas da área interna. Usa useGuardOr: se o usuário não tiver
 * nenhuma das permissões, é redirecionado para /error.
 */
export const InternalGuard: FC<PropsWithChildren<InternalGuardProps>> = ({ need, children }) => {
  useGuardOr(need)
  return <>{children}</>
}

export default InternalGuard
